import React from 'react';
import { ExchangeLogin } from './ExchangeLogin';
import { ExchangeList } from './ExchangeList/ExchangeList';

const { exchangeRequest } = window.inlineExchange || {};

// TODO if status error, display message and window.reload

const parseJSONString = jsonString => {
  return JSON.parse(jsonString.replace(/&quot;/g, '"'));
};

export const Exchange = () => {
  let defaultExchangeData = null;
  if (exchangeRequest) {
    const parsedMainObject = JSON.parse(JSON.stringify(exchangeRequest));
    defaultExchangeData = parseJSONString(parsedMainObject);
  }

  const [exchangeData, setExchangeData] = React.useState(defaultExchangeData);

  if (exchangeData?.data) {
    return <ExchangeList exchangeData={exchangeData.data} setExchangeData={setExchangeData} />;
  }

  return <ExchangeLogin setExchangeData={setExchangeData} />;
};
